module.exports = __webpack_public_path__ + "static/media/ball.75278a41.jpg";